export default function(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

export function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/numberArray.js
// module id = 197
// module chunks = 0 1